import { RequestInfo } from "store/slice/store.types";
import { ClientHubUser, Role } from "services/clienthub/clienthub.types";
import { SimpleEntity } from "types";

export type ConvertedClientHubUser = {
    id: number;
    name: string;
    email: string;
    linkedInId: string | null;
    position: string;
    company: string;
    activeOn: Date;
    personId: number | null;
    roles: Role[];
    function: string | undefined;
    status: RequestInfo;
};

export const convertClientHubUser = (data: ClientHubUser[], clientHub?: SimpleEntity): ConvertedClientHubUser[] => {
    return data.map((user) => {
        const userFunction = user.group_functions.find((func) => func.group_id === clientHub?.id)?.function.name;

        return {
            id: user.id,
            name: user.name,
            email: user.username,
            position: user.job_title,
            company: user.job_company_name,
            activeOn: user.last_active_datetime,
            roles: user.roles,
            function: userFunction,
            personId: user.person.id,
            linkedInId: user.person.linkedin_id,
            status: "pristine",
        };
    });
};
